import {HttpClient} from '@angular/common/http';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {Injectable} from '@angular/core';
import {AbstractDataServiceV2} from '../../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {SaleInvoiceConverter} from '../../../api/entity/converter/saleInvoice.converter';
import {CustomizeHttpUrlGenerator} from '../../../../../../../store/core/url/customizeHttpUrlGenerator';
import {SaleInvoiceModel} from '../../../api/entity/saleInvoice.model';

@Injectable({
    providedIn: 'root'
})
export class SaleInvoiceDataService extends AbstractDataServiceV2<SaleInvoiceModel, SaleInvoiceConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: SaleInvoiceConverter) {
        super('SaleInvoice', http, httpUrlGenerator, logger, config, converter);
    }
}
